export { default } from "./priorAuthorizationPage";
